import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TableSkeleton = (props) => {
    const { number } = props;
    const cellStyles = {
        fontSize: "0.813rem",
        whiteSpace: "nowrap",
        color: "#707C97",
        textAlign: "left",
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
        paddingBottom: "1rem",
        paddingTop: "1rem",
        lineHeight: "1.25rem",
        fontWeight: 500,
        backgroundColor: "#ffffff",
    };

    let loadingSkeleton = [];

    for (let i = 0; i < Number(number); i++) {
        loadingSkeleton.push(
            <td style={cellStyles}>
                <SkeletonTheme color="#ecf0f1" highlightColor="#fafbfb">
                    <Skeleton />
                </SkeletonTheme>
            </td>
        );
    }

    return (
        <tr role="row" className="w-full pr-5">
            {loadingSkeleton}
        </tr>
    );
};
export default TableSkeleton;
